import { DataGrid, GridColDef } from '@mui/x-data-grid';
import MainCard from '../ui-component/cards/MainCard';
import * as React from 'react';
import { useEffect } from 'react';
import axios from 'axios';
import { hearingAid } from './generator';
import { Button, Dialog, DialogContent, DialogTitle, Typography } from '@mui/material';
import HearingAidDialog, { ChargeType, HearingAid, HearingAidType } from '../ui-component/HearingAidDialog';

const HearingAids = () => {
    const [hearingAids, setHearingAids] = React.useState<[hearingAid]>([
        {
            id: '',
            StockCode: '',
            Price: '',
            Type: '',
            NappiCode: '',
            ChargeType: '',
            Description: '',
            Brand: ''
        }
    ]);

    const [showDialog, setShowDialog] = React.useState(false);
    const [selectedHearingAid, setSelectedHearingAid] = React.useState<HearingAid>({
        Brand: '',
        Colour: '',
        ProductClass: '',
        id: -1,
        StockCode: '',
        Price: 0,
        Type: HearingAidType.RIC,
        NappiCode: '',
        ChargeType: ChargeType.RECHARGABLE,
        Description: ''
    });

    const renderEditButton = (params: any) => {
        return (
            <Button
                variant="contained"
                color="primary"
                onClick={() => {
                    setSelectedHearingAid(params.row);
                    setShowDialog(true);
                }}
            >
                Edit
            </Button>
        );
    };

    const renderChargeType = (params: any) => {
        return (
            <Button
                variant="contained"
                color="primary"
                onClick={() => {
                    setSelectedHearingAid(params.row);
                    setShowDialog(true);
                }}
            >
                Edit
            </Button>
        );
    };

    const columns: GridColDef[] = [
        { field: 'Price', headerName: 'Price', width: 150 },
        { field: 'Type', headerName: 'Type', width: 150 },
        { field: 'NappiCode', headerName: 'Nappi Code', width: 150 },
        { field: 'Description', headerName: 'Name', width: 150 },
        { field: 'Brand', headerName: 'Brand', width: 150 },
        { field: 'ChargeType', headerName: 'Charge Type', width: 150 },
        { field: 'Actions', headerName: 'Actions', width: 150, renderCell: renderEditButton }
    ];

    const cancelDialog = () => {
        setShowDialog(false);
    };

    useEffect(() => {
        const fetchData = async () =>
            await axios.get('/api/list').then((value) => {
                setHearingAids(value.data);
            });
        fetchData();
    }, []);

    return (
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        <MainCard title="Hearing Aids">
            <Button
                onClick={() => {
                    setSelectedHearingAid({
                        Brand: '',
                        Colour: '',
                        ProductClass: '',
                        id: -1,
                        StockCode: '',
                        Price: 0,
                        Type: HearingAidType.RIC,
                        NappiCode: '',
                        ChargeType: ChargeType.RECHARGABLE,
                        Description: ''
                    });
                    setShowDialog(true);
                }}
                sx={{ mr: 2, mb: 2 }}
                variant="outlined"
            >
                Add Hearing Aid
            </Button>

            <Dialog open={showDialog} onClose={() => setShowDialog(false)}>
                <DialogTitle>
                    <Typography variant="h2">Add Hearing Aid</Typography>
                </DialogTitle>
                <DialogContent>
                    <HearingAidDialog
                        hearingAid={selectedHearingAid}
                        fullBrandList={hearingAids.map((value) => value.Brand)}
                        onCancel={cancelDialog}
                        onSubmit={async (e: HearingAid) => {
                            await axios.post('/api/hearingaid', e);
                            setShowDialog(false);

                            const fetchData = async () =>
                                await axios.get('/api/list').then((value) => {
                                    setHearingAids(value.data);
                                });
                            fetchData();
                        }}
                    />
                </DialogContent>
            </Dialog>

            <DataGrid
                autoHeight
                columns={columns}
                rows={hearingAids.filter((v, i, a) => a.findIndex((t) => t.NappiCode === v.NappiCode) === i)}
            />
        </MainCard>
    );
};

export default HearingAids;
